import { render, staticRenderFns } from "./bind-teacher-list.vue?vue&type=template&id=9673576e&scoped=true"
import script from "./bind-teacher-list.vue?vue&type=script&lang=js"
export * from "./bind-teacher-list.vue?vue&type=script&lang=js"
import style0 from "./bind-teacher-list.vue?vue&type=style&index=0&id=9673576e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9673576e",
  null
  
)

export default component.exports